import React from 'react'
import moment from 'moment'
import 'moment-timezone' // required: adds .tz() to moment used on lines 30 and 36
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'

const DateFormatTypes = {
  DateOnly: 'l',
  TimeOnly: 'LT',
  DateAndTime: 'M/D/YYYY h:mm a'
}

function FormatValue (formatType, SessionAccount, value, fixTimeZone) {
  let date = value

  let format = formatType

  switch (formatType) {
    case 'DateOnly':
      format = ((SessionAccount || {}).DateFormat || {}).DateOnly || DateFormatTypes.DateOnly
      break
    case 'TimeOnly':
      format = ((SessionAccount || {}).DateFormat || {}).TimeOnly || DateFormatTypes.TimeOnly
      break
    case 'DateAndTime':
      format = ((SessionAccount || {}).DateFormat || {}).DateAndTime || DateFormatTypes.DateAndTime
      break
  }

  if (!moment.isMoment(value)) {
    date = moment.tz(value, 'UTC')
  }
  if (date.isValid() === false) {
    return 'No Set'
  } else {
    if (fixTimeZone) {
      return date.tz(SessionAccount.TimeZoneIdIANA).format(format)
    } else {
      return date.format(format)
    }
  }
}

class DateFormatterPlain extends React.Component {
  static propTypes = buildPropTypes([
    sh.SessionAccount
  ], {
    formatType: pt.string,
    fixTimeZone: pt.bool
  })

  static defaultProps = {
    formatType: 'DateOnly',
    fixTimeZone: false
  }

  render () {
    const { formatType, SessionAccount, value, fixTimeZone } = this.props

    return FormatValue(formatType, SessionAccount, value, fixTimeZone)
  }
}

export const DateFormatter = compose(
  ReduxWrapper([
    sh.SessionAccount
  ])
)(DateFormatterPlain)

DateFormatter.FormatTypes = DateFormatTypes
DateFormatter.Format = FormatValue
